import documentInit from './modules/document';
import scrollNavInit from './modules/scroll-nav';
import smoothScrollInit from './modules/smooth-scroll';
import modalInit from './modules/modal';
import submissionForminit from './modules/submission-form';
import mobileNavInit from './modules/mobile-nav';
import slickInit from './modules/slick';

(function($){
		
	$(document).ready(function(){
		
		documentInit();
		smoothScrollInit();
		scrollNavInit();
		modalInit();
		mobileNavInit();
		
		submissionForminit();
		slickInit();
		
	});
		
})(jQuery);